import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { EmployeeCheckListDto } from './employee-check-list-dto.model';


export class EmployeeCheckListResponseDto implements IEmployeeCheckListResponseDto {
    employee!: EmployeeSummaryDto;
    branchName!: string | undefined;
    locationName!: string | undefined;
    departmentName!: string | undefined;
    designationName!: string | undefined;
    joinDate!: Date;
    isActive!: boolean;
    resignDate!: Date | undefined;
    employeeCheckLists!: EmployeeCheckListDto[] | undefined;

    constructor(data?: IEmployeeCheckListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.branchName = _data["branchName"];
            this.locationName = _data["locationName"];
            this.departmentName = _data["departmentName"];
            this.designationName = _data["designationName"];
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.resignDate = _data["resignDate"] ? new Date(_data["resignDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["employeeCheckLists"])) {
                this.employeeCheckLists = [] as any;
                for (let item of _data["employeeCheckLists"])
                    this.employeeCheckLists!.push(EmployeeCheckListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeCheckListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCheckListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["locationName"] = this.locationName;
        data["departmentName"] = this.departmentName;
        data["designationName"] = this.designationName;
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        if (Array.isArray(this.employeeCheckLists)) {
            data["employeeCheckLists"] = [];
            for (let item of this.employeeCheckLists)
                data["employeeCheckLists"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEmployeeCheckListResponseDto {
    employee: EmployeeSummaryDto;
    branchName: string | undefined;
    locationName: string | undefined;
    departmentName: string | undefined;
    designationName: string | undefined;
    joinDate: Date;
    isActive: boolean;
    resignDate: Date | undefined;
    employeeCheckLists: EmployeeCheckListDto[] | undefined;
}

